import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineProps,
  defineEmits,
  getCurrentInstance,
  defineExpose,
  nextTick,
  watchEffect,
} from "../../../../adapter-vue";
import 
TUIChatEngine,
{
  TUIStore,
  TUIGlobal,
  IMessageModel,
  TUITranslateService,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import copyIcon from "../../../../assets/icon/msg-copy.svg";
import delIcon from "../../../../assets/icon/msg-del.svg";
import revokeIcon from "../../../../assets/icon/msg-revoke.svg";
import { Toast, TOAST_TYPE } from "../../../common/Toast/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  messageItem: {
    type: Object,
    default: () => ({}),
  },
  isShowTool: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props


const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const isShow = ref(false);
const showToolList = ref(true);
const message = ref<IMessageModel>();
const TYPES = ref(TUIChatEngine.TYPES);

watchEffect(() => {
  message.value = props.messageItem;
  isShow.value = props.isShowTool;
});

const openMessage = (item: any) => {
  let url = "";
  switch (item.type) {
    case TUIChatEngine.TYPES.MSG_FILE:
      url = item.payload.fileUrl;
      break;
    case TUIChatEngine.TYPES.MSG_VIDEO:
      url = item.payload.remoteVideoUrl;
      break;
    case TUIChatEngine.TYPES.MSG_IMAGE:
      url = item.payload.imageInfoArray[0].url;
      break;
  }
  // window.open(url, "_blank");
};

const revokeMessage = (message: any) => {
  // 获取 messageModel
  const messageModel = TUIStore.getMessageModel(message.ID);
  let promise = messageModel.revokeMessage();
  promise.catch((error) => {
    // 调用异常时业务侧可以通过 promise.catch 捕获异常进行错误处理
    if ((error.code = 20016)) {
      const message = TUITranslateService.t("TUIChat.已过撤回时限");
      Toast({
        message,
        type: TOAST_TYPE.ERROR
      });
    }
  });
};

const deleteMessage = (message: any) => {
    // 获取 messageModel
  const messageModel = TUIStore.getMessageModel(message.ID);
  messageModel.deleteMessage();
};

const messageCopy = (message: any) => {
  if (isUniFrameWork.value) {
    uni.setClipboardData({
      data: message?.payload?.text,
    });
  }
};

return { __sfc: true,props, isPC, isUniFrameWork, isShow, showToolList, message, TYPES, openMessage, revokeMessage, deleteMessage, messageCopy, TUITranslateService, Icon, copyIcon, delIcon, revokeIcon }
}

})